if (!customElements.get('gift-packaging-selector')) {
  class GiftPackagingSelector extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
    }

    async onChange(event) {
      if (!event.target.matches('input[name="gift-packaging"]')) return;

      const selected = event.target.value;
      const label = event.target.dataset.label;
      const targetVariant = selected === 'hearts'
        ? this.dataset.heartsVariant
        : selected === 'premium'
          ? this.dataset.premiumVariant
          : '';

      await this.updatePackaging(targetVariant, label);
    }

    onClick(event) {
      const openButton = event.target.closest('[data-preview-open]');
      const closeButton = event.target.closest('[data-preview-close]');

      if (openButton) {
        event.preventDefault();
        document.getElementById(openButton.dataset.previewOpen)?.showModal();
      }

      if (closeButton) {
        event.preventDefault();
        closeButton.closest('dialog')?.close();
      }
    }

    async updatePackaging(targetVariant, label) {
      const inputs = this.querySelectorAll('input[name="gift-packaging"]');
      const checkoutButtons = this.closest('form')?.querySelectorAll('[name="checkout"]') || [];
      const status = this.querySelector('[data-packaging-status]');
      const packagingVariants = [
        Number(this.dataset.heartsVariant),
        Number(this.dataset.premiumVariant)
      ].filter(Boolean);

      inputs.forEach(input => { input.disabled = true; });
      checkoutButtons.forEach(button => { button.disabled = true; });
      status.textContent = this.dataset.updating;

      try {
        const cart = await fetch(`${window.Shopify.routes.root}cart.js`).then(response => {
          if (!response.ok) throw new Error('Cart request failed');
          return response.json();
        });
        const packagingItems = cart.items.filter(item => packagingVariants.includes(item.variant_id));
        const updates = {};
        let targetAlreadyInCart = false;

        packagingItems.forEach(item => {
          const keep = targetVariant && String(item.variant_id) === String(targetVariant);
          updates[item.key] = keep ? 1 : 0;
          targetAlreadyInCart = targetAlreadyInCart || keep;
        });

        const isDrawer = Boolean(this.closest('cart-drawer'));
        const mainCart = this.closest('cart-items');
        const sections = isDrawer
          ? ['cart-drawer', 'cart-counter']
          : [mainCart?.id, 'cart-counter'].filter(Boolean);
        const commonPayload = {
          sections,
          sections_url: window.location.pathname
        };

        let response = await fetch(window.routes.cart_update_url, {
          ...fetchConfig(),
          body: JSON.stringify({
            ...commonPayload,
            updates,
            attributes: { 'Empaque de regalo': label }
          })
        });

        if (!response.ok) throw new Error('Cart update failed');
        let state = await response.json();

        if (targetVariant && !targetAlreadyInCart) {
          response = await fetch(window.routes.cart_add_url, {
            ...fetchConfig(),
            body: JSON.stringify({
              ...commonPayload,
              items: [{
                id: Number(targetVariant),
                quantity: 1,
                properties: { _gift_packaging: 'true' }
              }]
            })
          });

          if (!response.ok) throw new Error('Cart add failed');
          state = await response.json();
        }

        if (isDrawer && state.sections) {
          document.querySelector('cart-drawer')?.renderContents(state);
        } else {
          window.location.reload();
        }
      } catch (error) {
        status.textContent = this.dataset.error;
        inputs.forEach(input => { input.disabled = false; });
        checkoutButtons.forEach(button => { button.disabled = false; });
      }
    }
  }

  customElements.define('gift-packaging-selector', GiftPackagingSelector);
}
